import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown, ChevronUp, Terminal, Trash2 } from 'lucide-react';
import useStore from '../store';

const LogPanel = () => {
    const { logs } = useStore();
    const [isExpanded, setIsExpanded] = useState(false); // 默认收起
    const logEndRef = useRef(null);

    useEffect(() => {
        if (isExpanded) {
            logEndRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, [logs, isExpanded]);

    return (
        <div className={`bg-gray-900 border-t border-gray-800 flex flex-col transition-all duration-300 ${isExpanded ? 'h-48' : 'h-9'}`}>
            {/* Header */}
            <div
                className="flex items-center justify-between px-4 py-2 bg-gray-800 cursor-pointer hover:bg-gray-750 select-none"
                onClick={() => setIsExpanded(!isExpanded)}
            >
                <div className="flex items-center gap-2 text-xs font-medium text-gray-300">
                    <Terminal size={14} className="text-blue-400" />
                    <span>System Logs</span>
                    <span className="bg-gray-700 px-1.5 py-0.5 rounded-full text-[10px] text-gray-400">
                        {logs.length}
                    </span>
                </div>
                <div className="flex items-center gap-2">
                    {isExpanded ? <ChevronDown size={14} className="text-gray-500" /> : <ChevronUp size={14} className="text-gray-500" />}
                </div>
            </div>

            {/* Content */}
            {isExpanded && (
                <div className="flex-1 overflow-y-auto p-2 font-mono text-xs bg-black/50">
                    {logs.length === 0 ? (
                        <div className="h-full flex items-center justify-center text-gray-600 italic">
                            No logs available. Waiting for activity...
                        </div>
                    ) : (
                        logs.map((log, i) => (
                            <div key={i} className="mb-1 break-all hover:bg-white/5 p-0.5 rounded">
                                <span className="text-gray-500 select-none">[{new Date(log.timestamp).toLocaleTimeString()}]</span>{' '}
                                <span className={`font-bold ${log.type === 'ERROR' ? 'text-red-400' :
                                    log.type === 'WARNING' ? 'text-yellow-400' :
                                        'text-green-400'
                                    }`}>
                                    [{log.type}]
                                </span>{' '}
                                <span className="text-gray-300">
                                    {typeof log.result === 'object' ? JSON.stringify(log.result) : (log.result || log.message || JSON.stringify(log))}
                                </span>
                            </div>
                        ))
                    )}
                    <div ref={logEndRef} />
                </div>
            )}
        </div>
    );
};

export default LogPanel;
